<p-toast></p-toast>
<div>
    <div class="card dashboardTable">
        <p-table #farmerShareToVendorPFMSReportTable [value]="farmerShareToVendorPFMSReportModel" [rows]="10"
            [paginator]="true"
            [globalFilterFields]="['Srno','Lot_No','dateofExport','Sum_of_PFMS_Export', 'SumOfABY_AllRec', 'SumOfTopUp_AllRec', 'Sum_of_Pending_Records', 'TargetDays', 'PendingCompletedDays', 'NoOfTimesExported', 'Sum_of_Successfull_Records','Sum_of_Failed_Records', 'Sum_of_Bank_Transfer_Successfull_Records', 'block', 'district', 'No_of_AllRecords', 'remarks', 'status','Status_Ar', 'village', 'lotNoForSorting', 'FinYear', 'No_of_Pending_Records', 'No_of_Failed_Records', 'Sum_of_Centre_Share', 'Sum_of_State_Share', 'No_of_Successfull_Records', 'No_of_Bank_Transfer_Successfull_Records']"
            [paginator]="true" responsiveLayout="scroll" [rowHover]="true" dataKey="Lot_No"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
            [tableStyle]="{'max-width': '80rem'}" sortField="lotNoForSorting" [sortOrder]="1">
            <ng-template pTemplate="caption">
                <div class="grid d-flex align-items-center justify-content-end"
                    [ngStyle]="{'color': 'black', 'background-color': 'white'}">
                    <!-- Left side -->
                    <div class="col-6 md:col-5">
                        <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{
                            'POND_SURVEY_TANK_STAGE2_PFMS_REPORTS' |
                            translate}}
                        </h5>
                    </div>
                    <!-- Middle section for buttons -->
                    <div class="col-6 md:col-3 d-flex justify-content-center">
                        <button (click)="menu.toggle($event)" pButton pRipple label="{{'' | translate}}"
                            icon="pi pi-download" class="p-button-help"></button>
                        <p-menu #menu [popup]="true" [model]="menuItems"></p-menu>
                        <button (click)="refreshTable()" pButton pRipple label="{{''| translate}}" icon="pi pi-refresh"
                            class="p-button-info ml-3"></button>
                    </div>
                    <!-- Right side for search -->
                    <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="farmerShareToVendorPFMSReportTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH' | translate}}" />
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <!-- <th pSortableColumn="Srno">{{'S_NO'| translate}}
                            <p-columnFilter type="text" field="Srno" display="menu"></p-columnFilter>
                            <p-sortIcon field="Srno"></p-sortIcon>
                        </th> -->
                    <th pSortableColumn="lotNoForSorting">{{'FILE_NO'| translate}}
                        <p-columnFilter type="text" field="Lot_No" display="menu"></p-columnFilter>
                        <p-sortIcon field="lotNoForSorting"></p-sortIcon>
                    </th>
                    <th pSortableColumn="dateofExport">{{'DATE_OF_EXPORT'| translate}}
                        <p-columnFilter type="text" field="dateofExport" display="menu"></p-columnFilter>
                        <p-sortIcon field="dateofExport"></p-sortIcon>
                    </th>
                    <th pSortableColumn="No_of_AllRecords">{{'NO_OF_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_AllRecords" display="menu"></p-columnFilter>
                        <p-sortIcon field="No_of_AllRecords"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_PFMS_Export">{{'SUM_OF_PFMS_EXPORT'| translate}}
                        <p-columnFilter type="text" field="Sum_of_PFMS_Export" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_PFMS_Export"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_Centre_Share">{{'SUM_OF_CENTRE_SHARE'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Centre_Share" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Centre_Share"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_State_Share">{{'SUM_OF_STATE_SHARE'| translate}}
                        <p-columnFilter type="text" field="Sum_of_State_Share" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_State_Share"></p-sortIcon>
                    </th>
                    <th pSortableColumn="SumOfTopUp_AllRec">{{'SUM_OF_TOPUP_AMOUNT'| translate}}
                        <p-columnFilter type="text" field="SumOfTopUp_AllRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="SumOfTopUp_AllRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="SumOfABY_AllRec">{{'SUM_OF_ABY_AMOUNT'| translate}}
                        <p-columnFilter type="text" field="SumOfABY_AllRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="SumOfABY_AllRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TargetDays">{{'TARGET_DAYS' | translate}}
                        <p-columnFilter type="text" field="TargetDays" display="menu"></p-columnFilter>
                        <p-sortIcon field="TargetDays"></p-sortIcon>
                    </th>
                    <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS' | translate}}
                        <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
                        <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                    </th>
                    <th pSortableColumn="NoOfTimesExported">{{'NO_OF_TIMES_EXPORTED' | translate}}
                        <p-columnFilter type="text" field="NoOfTimesExported" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfTimesExported"></p-sortIcon>
                    </th>
                    <th pSortableColumn="No_of_Successfull_Records">{{'NO_OF_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="No_of_Successfull_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_Successfull_Records">{{'SUM_OF_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="Sum_of_Successfull_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="No_of_Pending_Records">{{'NO_OF_PENDING_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_Pending_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="No_of_Pending_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_Pending_Records">{{'SUM_OF_PENDING_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Pending_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="Sum_of_Pending_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="No_of_Failed_Records">{{'NO_OF_FAILED_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_Failed_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="No_of_Failed_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_Failed_Records">{{'SUM_OF_FAILED_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Failed_Records" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Failed_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="No_of_Bank_Transfer_Successfull_Records">
                        {{'NO_OF_BANK_TRANSFER_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_Bank_Transfer_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="No_of_Bank_Transfer_Successfull_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_Bank_Transfer_Successfull_Records">
                        {{'SUM_OF_BANK_TRANSFER_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Bank_Transfer_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="Sum_of_Bank_Transfer_Successfull_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                        <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                        <p-sortIcon field="FinYear"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                    <!-- <td>{{product.Srno}}</td> -->
                    <td><button (click)="pmfsExport(product.Lot_No, '')" pButton pRipple type="button"
                            label="{{product.Lot_No}}" class="p-button-text"></button></td>
                    <td>{{product.dateofExport}}</td>
                    <td>{{product.No_of_AllRecords}}</td>
                    <td>{{product.Sum_of_PFMS_Export}}</td>
                    <td>{{product.Sum_of_Centre_Share}}</td>
                    <td>{{product.Sum_of_State_Share}}</td>
                    <td>{{product.SumOfTopUp_AllRec}}</td>
                    <td>{{product.SumOfABY_AllRec}}</td>
                    <td>{{product.TargetDays}}</td>
                    <td>{{product.PendingCompletedDays}}</td>
                    <td>{{product.NoOfTimesExported}}</td>
                    <td>{{product?.No_of_Successfull_Records}}</td>
                    <td><button (click)="pmfsExport(product.Lot_No, 'S')" pButton pRipple type="button"
                            label="{{product?.Sum_of_Successfull_Records}}" class="p-button-text"></button></td>
                    <td>{{product?.No_of_Pending_Records}}</td>
                    <td><button (click)="pmfsExport(product.Lot_No, 'P')" pButton pRipple type="button"
                            label="{{product?.Sum_of_Pending_Records}}" class="p-button-text"></button></td>
                    <td>{{product?.No_of_Failed_Records}}</td>
                    <td><button (click)="pmfsExport(product.Lot_No, 'F')" pButton pRipple type="button"
                            label="{{product?.Sum_of_Failed_Records}}" class="p-button-text"></button></td>
                    <td>{{product?.No_of_Bank_Transfer_Successfull_Records}}</td>
                    <td>{{product.Sum_of_Bank_Transfer_Successfull_Records}}</td>
                    <td>{{product.FinYear}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="flex  justify-content-between flex-column ">
                    <p>{{'IN_TOTAL_THERE_ARE' | translate}} {{farmerShareToVendorPFMSReportModel ?
                        farmerShareToVendorPFMSReportModel.length : 0 }} {{'RECORDS_ADDED' | translate}}
                    </p>
                    <div class="flex  justify-content-between flex-column ">
                        <div class="flex">
                            <div
                                style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_TWO_OR_MORE_DAYS' | translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_BY_ONE_DAY' | translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'APROVED_ON_TIME' | translate}}
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

<p-dialog [(visible)]="addDialog" [modal]="true" [style]="{ width: '100%', height: '100%' }" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="hideDialog()">
    <div class="mi-survey-container">
        <p-card styleClass="p-card-shadow">
            <div class="card dashboardTable">
                <p-table #miSurvey [value]="miSurveyData" [rows]="10" [paginator]="true" [globalFilterFields]="[
                    'Farmer_Name_In_English',
                    'Full_Name_in_Recognized_Official_Language',
                    'Caste_Description',
                    'Gender',
                    'Address_Line_1',
                    'Address_Line_2',
                    'Address_Line_3',
                    'District',
                    'State', 
                    'Country', 
                    'Farmer_Bank_Name', 
                    'Farmer_IFSC_Code',
                    'Farmer_Account_Number', 
                    'Aadhar_Number', 
                    'Pincode', 
                    'Scheme_Specific_Id',
                    'Center_Share_Payment_Amount',
                    'State_Share_Payment_Amount',
                    'Remarks',
                    'Applicant_type',
                    'userType',
                    'Coverage_Area',
                    'ABY',
                    'TopUp',
                    'TopUpPFMSPaymentDate'
                    ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
                    currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                    [showCurrentPageReport]="true" [loading]="loading1">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'FARMER_APPLICATION_FOR_POND_TANK2_PFMS_REPORT' | translate}}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH' | translate}}" />
                            </span>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="">{{'VIEW_APPLICATION' | translate}}</th>
                            <th pSortableColumn="Full_Name_In_English">{{'FULL_NAME_IN_ENGLISH' | translate}}
                                <p-columnFilter type="text" field="Full_Name_In_English"
                                    display="menu"></p-columnFilter>
                                <p-sortIcon field="Full_Name_In_English"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Full_Name_in_Recognized_Official_Language">
                                {{'FULL_NAME_IN_RECOGNIZED_OFFICIAL_LANGUAGE' | translate}}
                                <p-columnFilter type="text" field="Full_Name_in_Recognized_Official_Language"
                                    display="menu"></p-columnFilter>
                                <p-sortIcon field="Full_Name_in_Recognized_Official_Language"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Caste_Description">
                                {{'CASTE' | translate}}
                                <p-columnFilter type="text" field="Caste_Description" display="menu"></p-columnFilter>
                                <p-sortIcon field="Caste_Description"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Gender">{{'GENDER' | translate}}
                                <p-columnFilter type="text" field="Gender" display="menu"></p-columnFilter>
                                <p-sortIcon field="Gender"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_1">{{'ADDRESSLINE1' | translate}}
                                <p-columnFilter type="text" field="Address_Line_1" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_1"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_2">{{'ADDRESSLINE2' | translate}}
                                <p-columnFilter type="text" field="Address_Line_2" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_2"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_3">{{'ADDRESSLINE3' | translate}}
                                <p-columnFilter type="text" field="Address_Line_3" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_3"></p-sortIcon>
                            </th>
                            <th pSortableColumn="District">{{'DISTRICT' | translate}}
                                <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                                <p-sortIcon field="District"></p-sortIcon>
                            </th>
                            <th pSortableColumn="State">{{'STATE' | translate}}
                                <p-columnFilter type="text" field="State" display="menu"></p-columnFilter>
                                <p-sortIcon field="State"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Country">{{'COUNTRY' | translate}}
                                <p-columnFilter type="text" field="Country" display="menu"></p-columnFilter>
                                <p-sortIcon field="Country"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Farmer_Bank_Name">{{'FARMER_BANK_NAME' | translate}}
                                <p-columnFilter type="text" field="Farmer_Bank_Name" display="menu"></p-columnFilter>
                                <p-sortIcon field="Farmer_Bank_Name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Farmer_IFSCCode">{{'FARMER_IFSCCODE' | translate}}
                                <p-columnFilter type="text" field="Farmer_IFSCCode" display="menu"></p-columnFilter>
                                <p-sortIcon field="Farmer_IFSCCode"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Farmer_Account_Number">{{'FARMER_ACCOUNT_NUMBER' | translate}}
                                <p-columnFilter type="text" field="Farmer_Account_Number" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Farmer_Account_Number"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Aadhar_Number">{{'AADHAR_NUMBER' | translate}}
                                <p-columnFilter type="text" field="Aadhar_Number" display="menu"></p-columnFilter>
                                <p-sortIcon field="Aadhar_Number"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Pincode">{{'PINCODE' | translate}}
                                <p-columnFilter type="text" field="Pincode" display="menu"></p-columnFilter>
                                <p-sortIcon field="Pincode"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Scheme_Specific_Id">{{'SCHEME_SPECIFIC_ID' | translate}}
                                <p-columnFilter type="text" field="Scheme_Specific_Id" display="menu"></p-columnFilter>
                                <p-sortIcon field="Scheme_Specific_Id"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Center_Share_Payment_Amount">{{'CENTER_SHARE_PAYMENT_AMOUNT' |
                                translate}}
                                <p-columnFilter type="text" field="Center_Share_Payment_Amount" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Center_Share_Payment_Amount"></p-sortIcon>
                            </th>
                            <th pSortableColumn="State_Share_Payment_Amount">{{'STATE_SHARE_PAYMENT_AMOUNT' |
                                translate}}
                                <p-columnFilter type="text" field="State_Share_Payment_Amount" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="State_Share_Payment_Amount"></p-sortIcon>
                            </th>
                            <th pSortableColumn="ABY">{{'ABY' | translate}}
                                <p-columnFilter type="text" field="ABY" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="ABY"></p-sortIcon>
                            </th>
                            <th pSortableColumn="TopUp">{{'TOP_UP' | translate}}
                                <p-columnFilter type="text" field="TopUp" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="TopUp"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Applicant_type">{{'APPLICATION_TYPE' | translate}}
                                <p-columnFilter type="text" field="Applicant_type" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Applicant_type"></p-sortIcon>
                            </th>
                            <th pSortableColumn="userType">{{'USER_TYPE' | translate}}
                                <p-columnFilter type="text" field="userType" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="userType"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Coverage_Area">{{'COVERAGE_AREA' | translate}}
                                <p-columnFilter type="text" field="Coverage_Area" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Coverage_Area"></p-sortIcon>
                            </th>
                            <th pSortableColumn="TopUpPFMSPaymentDate">{{'TOP_UP_PFMS_PAYMENT_DATE' | translate}}
                                <p-columnFilter type="text" field="TopUpPFMSPaymentDate" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="TopUpPFMSPaymentDate"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Remarks">{{'REMARKS' | translate}}
                                <p-columnFilter type="text" field="Remarks" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Remarks"></p-sortIcon>
                            </th>
                            <th pSortableColumn="CAORemarks">{{'CAO_REMARKS' | translate}}
                                <p-columnFilter type="text" field="CAORemarks" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="CAORemarks"></p-sortIcon>
                            </th>
                            <!-- <th pSortableColumn="Subsidy_Amt">Subsidy Amount
                                <p-columnFilter type="text" field="Subsidy_Amt" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Subsidy_Amt"></p-sortIcon>
                            </th>
                            <th pSortableColumn="ApprovalDate">ApprovalDate
                                <p-columnFilter type="text" field="ApprovalDate" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="ApprovalDate"></p-sortIcon>
                            </th> -->
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>
                            <td>
                                <button pButton pRipple pTooltip="{{'VIEW_APPLICATION' | translate}}" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="selectFarmerApplication(product)"></button>
                            </td>
                            <td>{{product.Farmer_Name_In_English}}</td>
                            <td>{{product.Full_Name_in_Recognized_Official_Language}}</td>
                            <td>{{product.Caste_Description}}</td>
                            <td>{{product.Gender}}</td>
                            <td>{{product.Address_Line_1}}</td>
                            <td>{{product.Address_Line_2}}</td>
                            <td>{{product.Address_Line_3}}</td>
                            <td>{{product.District}}</td>
                            <td>{{product.State}}</td>
                            <td>{{product.Country}}</td>
                            <td>{{product.Farmer_Bank_Name}}</td>
                            <td>{{product.Farmer_IFSCCode}}</td>
                            <td>{{product.Farmer_Account_Number}}</td>
                            <td>{{product.Aadhar_Number}}</td>
                            <td>{{product.Pincode}}</td>
                            <td>{{product.Scheme_Specific_Id}}</td>
                            <td>{{product.Center_Share_Payment_Amount}}</td>
                            <td>{{product.State_Share_Payment_Amount}}</td>
                            <td>{{product?.ABY}}</td>
                            <td>{{product?.TopUp}}</td>
                            <td>{{product.Applicant_type}}</td>
                            <td>{{product.userType}}</td>
                            <td>{{product.Coverage_Area}}</td>
                            <td>{{product?.TopUpPFMSPaymentDate}}</td>
                            <td>{{product.Remarks}}</td>
                            <td>{{product.CAORemarks}}</td>
                            <!-- <td>{{product.Subsidy_Amt}}</td>
                            <td>{{product.ApprovalDate}}</td> -->

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            {{'IN_TOTAL_THERE_ARE' | translate}} {{miSurveyData ? miSurveyData?.length : 0 }}
                            {{'POND_SURVEY_TANK2_PFMS_REPORT_APPLICATIONS_ADDED' | translate}}
                        </div>
                    </ng-template>
                </p-table>
            </div>
            <div class="card">
                <h5><b>Total No. of Applications Filtered For Pond Survey Tank Stage 2 PFMS Reports: {{
                        miSurveyData?.length }}</b>
                </h5>
                <!-- <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4">
                        <p>Total Subsidy To Farmer Amount: {{ totalSubToFarmer }}</p>
                    </div>
                    <div class="field col-12 md:col-4">
                        <p>Total Subsidy To Vendor Amount: {{ totalSubToVendor }}</p>
                    </div>
                    <div class="field col-12 md:col-4">
                        <p>Total Farmer Refund Amount: {{ totalFarmerRefund }}</p>
                    </div>
                </div> -->
                <div class="flex justify-content-end">
                    <button (click)="menu.toggle($event)" pButton pRipple p-button-info
                        label="{{'DOWNLOAD_FILTERED_LOT_DATA' | translate}}" icon="pi pi-upload"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"
                        styleClass="prime-slider-override"></p-menu>
                </div>

                <!-- <div class="card">
                    <p-toolbar *ngIf="filteredData.length">
                        <ng-template pTemplate="left">

                        </ng-template>
                        <ng-template pTemplate="right">
                            <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                                class="mr-3">
                            </p-dropdown>
                            <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea
                                required rows="3" cols="20" class="mr-3"></textarea>
                            <button pButton pRipple label="Submit" (click)="handleClick()"
                                class="p-button-help"></button>
                        </ng-template>
                    </p-toolbar>
                </div> -->
            </div>

        </p-card>
    </div>
</p-dialog>